module.exports = __webpack_public_path__ + "img/luna-amber.439bf494.png";